import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { text } from '../text';
import { URLS } from '../config';
import { hooks } from '../hooks';
import { theme } from '../constants';
import { components } from '../components';
import homeimg from '../assets/nestfin/homeimg.jpg'
import mybooking from '../assets/nestfin/mybooking.jpg'
import helpcenter from '../assets/nestfin/helpcenter.jpg'


export const Dashboard: React.FC = () => {
    const location = useLocation();
    const { pathname } = useLocation();

    useEffect(() => {
        const scrollToTop = () => {
            window.scrollTo(0, 0);
            document.documentElement.scrollTop = 0;
        };

        scrollToTop();
    }, [pathname]);

    const navigate = hooks.useNavigate();

    const [loading, setLoading] = useState(false);
    
    const [categoriesData, setCategoriesData] = useState<any[]>([
        {
            id: 1,
            name: "My Bookings",
            quantity: "7",
            image: mybooking,
            link: "/my-booking"
        },
        {
            id: 3,
            name: "Home",
            quantity: "17",
            image: homeimg,
            link: "/home"
        },
        {
            id: 4,
            name: "Help Center",
            quantity: "23",
            image: helpcenter,
            link: "/help-center"
        },
       
    ]);

    // const [categoriesData, setCategoriesData] = useState<any[]>([
    //     {
    //         "id": 1,
    //         "name": "My Bookings",
    //         "quantity": "7",
    //         "image": "https://img.freepik.com/free-photo/beautiful-shot-big-farmhouse-clear-blue-sky_181624-15996.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740"

    //     },
    //     {
    //         "id": 2,
    //         "name": "Shortlisted Properties",
    //         "quantity": "20",
    //         "image": "https://img.freepik.com/free-photo/framing-landscape-while-traveling_23-2149887691.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740"
    //     },
    //     {
    //         "id": 3,
    //         "name": "Report a Fraud",
    //         "quantity": "17",
    //         "image": "https://img.freepik.com/free-vector/global-data-security-personal-data-security-cyber-data-security-online-concept-illustration-internet-security-information-privacy-protection_1150-37368.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740"
    //     },
    //     {
    //         "id": 4,
    //         "name": "Help Center",
    //         "quantity": "23",
    //         "image": "https://img.freepik.com/free-photo/close-up-person-working-call-center_23-2149288225.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740"
    //     },
    //     {
    //         "id": 5,
    //         "name": "Latest Offer",
    //         "quantity": "5",
    //         "image": "https://img.freepik.com/free-photo/woman-holding-upload-icon-laptop_53876-71043.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740"
    //     },
    //     {
    //         "id": 6,
    //         "name": "My Profile",
    //         "quantity": "14",
    //         "image": "https://img.freepik.com/free-vector/boy-with-smartphone-social-profile-commnication_24877-53919.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740"
    //     }
    // ]

    // );




    const renderHeader = (): JSX.Element => {
        return (
            <components.Header
                title='Dashboard'
                goBack={true}
            />
        );
    };

    const renderContent = (): JSX.Element => {
        return (
            <main style={{ paddingBottom: 0 }}>
                <div
                    className='container'
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 15,
                        marginTop: 10,
                        marginBottom: 20,
                    }}
                >
                    <div style={{ width: 'calc(50% - 7.5px)' }}>
                        {categoriesData.slice(0, 2).map((category: any, index, array) => {
                            const isLast = index === array.length - 1;
                            return (
                                // column 1
                                <div
                                    key={category.id}
                                    style={{
                                        width: '100%',
                                        height: 260,
                                        cursor: 'pointer',
                                        userSelect: 'none',
                                        padding: '30px 10px',
                                        position: 'relative',
                                        marginBottom: isLast ? 0 : 15,
                                    }}
                                    onClick={() => {
                                        navigate(category.link);
                                    }}
                                >
                                    <img
                                        src={category.image}
                                        alt={category.name}
                                        style={{
                                            height: '100%',
                                            width: '100%',
                                            objectFit: 'cover',
                                            borderRadius: 10,
                                            position: 'absolute',
                                            inset: 0,
                                            zIndex: -2,
                                        }}
                                    />
                                    <div
                                        style={{
                                            position: 'absolute',
                                            inset: 0,
                                            // backgroundColor: 'rgba(0, 0, 0, 0.4)',
                                            backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.1))',

                                            borderRadius: 10,
                                            zIndex: -1,
                                        }}
                                    />
                                    <text.H2
                                        style={{
                                            color: theme.colors.white,
                                            textTransform: 'capitalize',
                                        }}
                                    >
                                        {category.name}
                                    </text.H2>
                                    {/* <div className='dashboardNumber'
                                        style={{
                                            color: theme.colors.white,
                                            ...theme.fonts.Lato_700Bold,
                                        }}
                                    >
                                        {category.quantity}
                                    </div> */}
                                </div>

                            );
                        })}
                    </div>
                    {/* Dashboard Column 2 */}
                    <div style={{ width: 'calc(50% - 7.5px)' }}>
                        {categoriesData.slice(2, 6).map((category: any, index, array) => {
                            const isLast = index === array.length - 1;
                            return (
                                <div
                                    key={category.id}
                                    style={{
                                        width: '100%',
                                        height: 210,
                                        cursor: 'pointer',
                                        userSelect: 'none',
                                        position: 'relative',
                                        marginBottom: isLast ? 0 : 15,
                                        padding: '30px 10px',
                                    }}
                                    onClick={() => {
                                        navigate(category.link);
                                    }}
                                // onClick={() => {
                                //     navigate('/category-list', { state: { title: category.name } });
                                // }}
                                >
                                    <img
                                        src={category.image}
                                        alt={category.name}
                                        style={{
                                            height: '100%',
                                            width: '100%',
                                            objectFit: 'cover',
                                            borderRadius: 10,
                                            position: 'absolute',
                                            inset: 0,
                                            zIndex: -2,


                                        }}
                                    />
                                    <div
                                        style={{
                                            position: 'absolute',
                                            inset: 0,
                                            backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.1))',
                                            borderRadius: 10,
                                            zIndex: -1,
                                        }}
                                    />
                                    <text.H2
                                        style={{
                                            color: theme.colors.white,
                                            textTransform: 'capitalize',
                                        }}
                                    >
                                        {category.name}
                                    </text.H2>
                                    {/* <div
                                        className='dashboardNumber'
                                        style={{
                                            color: theme.colors.white,
                                            ...theme.fonts.Lato_700Bold,
                                        }}
                                    >
                                        {category.quantity}
                                    </div> */}
                                </div>

                            );
                        })}
                    </div>
                </div>
            </main>
        );
    };

    return (
        <>

            {renderHeader()}
            {renderContent()}
        </>
    );
};





// import axios from 'axios';
// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// import { text } from '../text';
// import { URLS } from '../config';
// import { hooks } from '../hooks';
// import { theme } from '../constants';
// import { components } from '../components';

// export const Dashboard: React.FC = () => {
//     const location = useLocation();
//     const { pathname } = useLocation();

//     useEffect(() => {
//         const scrollToTop = () => {
//             window.scrollTo(0, 0);
//             document.documentElement.scrollTop = 0;
//         };

//         scrollToTop();
//     }, [pathname]);

//     const navigate = hooks.useNavigate();

//     const [loading, setLoading] = useState(false);
//     const [categoriesData, setCategoriesData] = useState<any[]>([]);

//     const getData = async () => {
//         setLoading(true);

//         try {
//             const results = await Promise.allSettled([
//                 axios.get(URLS.GET_CATEGORIES),
//             ]);

//             const categoriesResponse = results[0];

//             if (categoriesResponse.status === 'fulfilled') {
//                 console.log(categoriesResponse.value.data.categories)
//                 setCategoriesData(categoriesResponse.value.data.categories);

//             } else {
//                 console.error('Error fetching categories:', categoriesResponse.reason);
//             }
//         } catch (error) {
//             console.error('Unexpected error:', error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         getData();
//     }, []);

//     const renderImageBackground = (): JSX.Element => {
//         return <components.Background version={1} />;
//     };

//     const renderHeader = (): JSX.Element => {
//         return (
//             <components.Header
//                 title='Dashboard'
//                 goBack={true}
//             />
//         );
//     };

//     const renderContent = (): JSX.Element => {
//         return (
//             <main style={{ paddingBottom: 0 }}>
//                 <div
//                     className='container'
//                     style={{
//                         display: 'flex',
//                         flexDirection: 'row',
//                         gap: 15,
//                         marginTop: 10,
//                         marginBottom: 20,
//                     }}
//                 >
//                     <div style={{ width: 'calc(50% - 7.5px)' }}>
//                         {categoriesData.slice(0, 3).map((category: any, index, array) => {
//                             const isLast = index === array.length - 1;
//                             return (
//                                 <div
//                                     key={category.id}
//                                     style={{
//                                         width: '100%',
//                                         height: 260,
//                                         cursor: 'pointer',
//                                         userSelect: 'none',
//                                         padding: '30px 10px',
//                                         position: 'relative',
//                                         marginBottom: isLast ? 0 : 15,
//                                     }}
//                                     onClick={() => {
//                                         navigate('/category-list', { state: { title: category.name } });
//                                     }}
//                                 >
//                                     <img
//                                         src={category.image}
//                                         alt={category.name}
//                                         style={{
//                                             height: '100%',
//                                             width: '100%',
//                                             objectFit: 'cover',
//                                             borderRadius: 10,
//                                             position: 'absolute',
//                                             inset: 0,
//                                             zIndex: -1,
//                                         }}
//                                     />
//                                     <text.H2
//                                         style={{
//                                             color: theme.colors.white,
//                                             textTransform: 'capitalize',
//                                         }}
//                                     >
//                                         {category.name}
//                                     </text.H2>
//                                     <text.T14
//                                         style={{
//                                             color: theme.colors.white,
//                                             ...theme.fonts.Lato_700Bold,
//                                         }}
//                                     >
//                                         {category.quantity} Courses
//                                     </text.T14>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                     {/* Dashboard Column 2 */}
//                     <div style={{ width: 'calc(50% - 7.5px)' }}>
//                         {categoriesData.slice(3, 6).map((category: any, index, array) => {
//                             const isLast = index === array.length - 1;
//                             return (
//                                 <div
//                                     key={category.id}
//                                     style={{
//                                         width: '100%',
//                                         height: 210,
//                                         cursor: 'pointer',
//                                         userSelect: 'none',
//                                         position: 'relative',
//                                         marginBottom: isLast ? 0 : 15,
//                                         padding: '30px 10px',
//                                     }}
//                                     onClick={() => {
//                                         navigate('/category-list', { state: { title: category.name } });
//                                     }}
//                                 >
//                                     <img
//                                         src={category.image}
//                                         alt={category.name}
//                                         style={{
//                                             height: '100%',
//                                             width: '100%',
//                                             objectFit: 'cover',
//                                             borderRadius: 10,
//                                             position: 'absolute',
//                                             inset: 0,
//                                             zIndex: -1,
//                                         }}
//                                     />
//                                     <text.H2
//                                         style={{
//                                             color: theme.colors.white,
//                                             textTransform: 'capitalize',
//                                         }}
//                                     >
//                                         {category.name}
//                                     </text.H2>
//                                     <text.T14
//                                         style={{
//                                             color: theme.colors.white,
//                                             ...theme.fonts.Lato_700Bold,
//                                         }}
//                                     >
//                                         {category.quantity} Courses
//                                     </text.T14>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 </div>
//             </main>
//         );
//     };

//     return (
//         <>

//             {renderHeader()}
//             {renderContent()}
//         </>
//     );
// };
